"use client";

import styled from "styled-components";

export const Title = styled.h1`
  color: var(--colorTitle);
  font-family: "Helvetica Neue";
  font-size: 1.2rem;
`;
